import { ReadAuditLog } from "@/types/auditLog";
import { useTranslation } from "react-i18next";

const operationBadgeStyles: Record<string, string> = {
  INSERT: "bg-green-600 text-white",
  UPDATE: "bg-blue-600 text-white",
  DELETE: "bg-red-600 text-white",
};

interface AuditLogOperationBadgeProps {
  operation: ReadAuditLog["operation"];
}

export const AuditLogOperationBadge = ({
  operation,
}: AuditLogOperationBadgeProps) => {
  const { t } = useTranslation();
  const operationLabel = t(`auditLogs.dbOperation.${operation}`);

  return (
    <span
      className={`px-2 py-0.5 rounded text-sm font-medium ${operationBadgeStyles[operation] || ""}`}
    >
      {operationLabel}
    </span>
  );
};
